<div
  *ngIf="view$ | async as view"
  [ngClass]="{ shadow: view.isPlaying }"
  class="border rounded hover-bg-grey-200 m-0 m-md-2 mb-2"
>
  <flo-stream-tile-thumbnail
    [props]="streamTileThumbnailProps$ | async"
  ></flo-stream-tile-thumbnail>
  <div class="p-3 headline font-family-bold">
    {{ view.title }}
  </div>
</div>
